module.exports = __webpack_public_path__ + "img/kc5.311924d1.png";